import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Popover from '@material-ui/core/Popover';
import NotificationBell from './NotificationBell';
import NotificationsList from './NotificationsList';
import { findDOMNode } from 'react-dom';
import { connect } from 'react-redux';
import { actions } from '../../store';



const styles = theme => ({
	root: {
		marginTop: 8,
	},
	badge: {
		margin: `0 ${theme.spacing.unit * 2}px`,
	},
	popover: {
		minWidth: 300,
		minHeight: 50,
	},
});



class Notifications extends React.PureComponent {

	state = {
		open: false,
		anchorEl: null,
	};


	componentDidMount = () => {
		this.props.refreshNotifications();
	};


	handleOpen = () => {
		this.setState( {
			open: true,
			anchorEl: findDOMNode( this.anchor ),
		} );
	};


	handleClose = () => {
		this.setState( {
			open: false,
		} );
	};


	anchor = null;


	render() {
		const classes = this.props.classes;

		return (
			<div className={classes.root}>
				<NotificationBell
					ref={node => {
						this.anchor = node;
					}}
					notifications={this.props.notifications}
					onClick={this.handleOpen}
				/>

				<Popover
					open={this.state.open}
					anchorEl={this.state.anchorEl}
					onClose={this.handleClose}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'center',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'center',
					}}
					className={classes.popover}
				>
					<NotificationsList
						notifications={this.props.notifications}
						handleClose={this.handleClose}
					/>
				</Popover>
			</div>
		);
	}
}



const mapStateToProps = state => {
	return {
		notifications: state.notifications,
	};
};


const mapDispatchToProps = dispatch => {
	return {
		refreshNotifications: () => {
			dispatch( actions.notifications.refresh() );
		},
	}
};


export default connect( mapStateToProps, mapDispatchToProps )( withStyles( styles )( Notifications ) );